import { AUTOCOMPLETE_FIELD_TYPE, DATE_RANGE_FIELD_TYPE, INTEGER_RANGE_FIELD_TYPE, TEXT_FIELD_TYPE } from "../../../../helpers/constants";
import i18n from "../../../../i18n";
import DateService from "../../../../services/dateService";



export const ANSWER_TABLE_NAME = "answer_registry";

export const ANSWER_TABLE_FIELDS_CONFIG = [

  {
    name: "hrsurvey_name",
    getValueCallback: (rowData) => rowData.hrsurvey_name,
    label: i18n.t("table.survey_registry_table.hrsurvey_name"),
    filterType: TEXT_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
  },
  {
    name: "hrsurvey_date_send",
    label: i18n.t("table.survey_registry_table.hrsurvey_date_send"),
    getValueCallback: (rowData) => DateService.convertDateToFormatYYYYMMDD(rowData.hrsurvey_date_send),
    filterType: DATE_RANGE_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
  },
  {
    name: "hrsurvey_goal",
    getValueCallback: (rowData) => rowData.hrsurvey_goal,
    label: i18n.t("table.survey_registry_table.hrsurvey_goal"),
    filterType: TEXT_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
  },
  {
    name: "hrsurvey_date_close",
    getValueCallback: (rowData) =>
      DateService.convertDateToFormatYYYYMMDD(rowData.hrsurvey_date_close),
    label: i18n.t("table.survey_registry_table.hrsurvey_date_close"),
    filterType: DATE_RANGE_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => ({
      style: { minWidth: "100px" },
    }),
  },
  {
    name: "hrsurvey_date_expired",
    getValueCallback: (rowData) =>
      DateService.convertDateToFormatYYYYMMDD(rowData.hrsurvey_date_expired),
    label: i18n.t("table.survey_registry_table.hrsurvey_date_expired"),
    filterType: DATE_RANGE_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => ({
      style: { minWidth: "100px" },
    }),
  },
  {
    name: "organizer",
    getValueCallback: (rowData) => rowData.organizer,
    label: i18n.t("table.survey_registry_table.organizer"),
    filterType: AUTOCOMPLETE_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => ({
      options: filteringData?.value?.users,
      isObjectOption: true,
      addNewValue: false,
      multiple: true,
      optionLabelKey: "full_name"
    }),
  },
  {
    name: "evaluator",
    getValueCallback: (rowData) => rowData.evaluator,
    label: i18n.t("table.survey_registry_table.evaluator"),
    filterType: AUTOCOMPLETE_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => ({
      options: filteringData?.value?.users,
      isObjectOption: true,
      addNewValue: false,
      multiple: true,
      optionLabelKey: "full_name"
    }),
  },
  {
    name: "evaluator_role",
    getValueCallback: (rowData) => rowData.evaluator_role,
    label: i18n.t("table.survey_registry_table.evaluator_role"),
    filterType: AUTOCOMPLETE_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => ({
      options: filteringData?.value?.roles,
      isObjectOption: true,
      addNewValue: false,
      multiple: true,
      optionLabelKey: "hrrole_name"
    }),
  },
  {
    name: "evaluated",
    getValueCallback: (rowData) => rowData.evaluated,
    label: i18n.t("table.survey_registry_table.evaluated"),
    filterType: AUTOCOMPLETE_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => ({
      options: filteringData?.value?.users,
      isObjectOption: true,
      addNewValue: false,
      multiple: true,
      optionLabelKey: "full_name"
    }),
  },
  {
    name: "questionkind",
    getValueCallback: (rowData) => rowData.questionkind,
    label: i18n.t("table.survey_registry_table.questionkind"),
    filterType: TEXT_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
  },
  {
    name: "question",
    getValueCallback: (rowData) => rowData.question,
    label: i18n.t("table.survey_registry_table.question"),
    filterType: TEXT_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
  },
  {
    name: "score_count",
    getValueCallback: (rowData) => rowData.score_count,
    label: i18n.t("table.survey_registry_table.score_count"),
    filterType: INTEGER_RANGE_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
  },
  {
    name: "hranswer_note",
    getValueCallback: (rowData) => rowData.hranswer_note,
    label: i18n.t("table.survey_registry_table.hranswer_note"),
    filterType: TEXT_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
  },
  {
    name: "hranswer_date_answer",
    getValueCallback: (rowData) =>
      DateService.convertDateToFormatYYYYMMDD(rowData.hranswer_date_answer),
    label: i18n.t("table.survey_registry_table.hranswer_date_answer"),
    filterType: DATE_RANGE_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => ({
      style: { minWidth: "100px" },
    }),
  },

];
